import React from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import './PortfolioCard.css';
import { PortfolioProjectCard } from './PortfolioProjectCard/PortfolioProjectCard';

const PortfolioCard = ({ openPortfolioPopup, submissions }) => (
  <div className="col-12">
    <div className="row">
      <div className="col">
        <p className="t-19 my-4">Portfolio</p>
      </div>
    </div>
    <div className="bg-white shadow-mid p-4 pb-2 pt-6 position-relative">
      <div className="row">
        <div className="plus-button" onClick={openPortfolioPopup} />
        {submissions.map(submission => (
          <PortfolioProjectCard key={submission.id} project={submission} />
        ))}
        {isEmpty(submissions) && (
          <div className="col text-center pb-10 pb-md-20 mb-10 mb-md-20 pt-9 pt-md-19 mt-9 mt-17">
            <p className="t-20">Your portfolio is empty</p>
            <p className="text-darkgreen font-weight-bold t-15">
              You cannot be assigned projects until you have completed filling
              out your profile.
            </p>
          </div>
        )}
      </div>
    </div>
  </div>
);

PortfolioCard.propTypes = {
  openPortfolioPopup: PropTypes.func,
  submissions: PropTypes.array,
};

export default PortfolioCard;



// WEBPACK FOOTER //
// ./src/components/DashboardFreelancerMain/PortfolioCard/PortfolioCard.js